// noinspection JSUnusedLocalSymbols
define([
  "marionette",
  "underscore",
  "jquery",
  "messaging/messenger",
  "./topicAttributesView",
  "./topicAttributesModel",
  "modules/shared/sortableList/sortableListModule",
  "modules/header/kbMenu/kbMenuModel",
], function (
  Marionette,
  _,
  $,
  Messenger,
  TopicAttributesView,
  TopicAttributesModel,
  SortableListModule,
  KbMenuModel,
) {
  var TopicAttributesController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicAttributes";
      this.region = options.region;
    },

    _buildView: function () {
      var allowDeleteAttributes = Messenger.reqres.request("can:delete:topicAttributes");
      var allowEditAttributes = Messenger.reqres.request("can:edit:topicAttributes");

      this.view = new TopicAttributesView.topicAttributesView({
        allowDeleteAttributes: allowDeleteAttributes,
        allowEditAttributes: allowEditAttributes,
        collection: this.topicAttributes,
        attributeList: this.kbAttributes,
        languagesWithDefault: this.languagesWithDefault,
        selectedLanguage: this.selectedLanguage,
      });
      var _this = this;
      this.view.on("add:attribute", function () {
        if (allowEditAttributes) {
          var success = _this._addAttribute(this.attributeList, this.collection);
          if (success) {
            // re-render view to update attribute drop down values
            _this.view.render();
          }
        }
      });
      this.view.on(
        "change:selectedLanguageId",
        function (languageId) {
          var language = this.languagesWithDefault.findWhere({
            id: languageId,
          });
          this.selectedLanguage = language;
          this.view.setSelectedLanguage(this.selectedLanguage);
        },
        this,
      );

      this.view.on(
        "itemview:change:attribute",
        function (itemView, attributeId, attributeName) {
          let attribute = this.kbAttributes.findWhere({ id: attributeId });
          _this._changeAttributeId(itemView, attributeId, attributeName, attribute.get("dataType"));
          // re-render view to update attribute drop down values
          _this.view.render();
        },
        this,
      );

      this.view.on("itemview:delete:attribute", function (itemView) {
        if (allowDeleteAttributes) {
          Messenger.yesNoDialog(
            "topic.attributes.deleteDialog",
            {
              yes: function () {
                const topicId = Messenger.reqres.request("current:topic:id");
                Messenger.vent.trigger("track:interaction", {
                  action: "Delete Topic Attribute",
                  id: [topicId, itemView.model.id],
                  idType: ["Topic", "Topic Attribute"],
                  object: "Topic Attribute",
                });
                itemView.model.deleteModel();
                // re-render view to update attribute drop down values
                _this.view.render();
              },
            },
            this,
          );
        }
      });
    },

    show: function (topicAttributes, readOnly) {
      this.topicAttributes = topicAttributes;
      this.topicAttributes.readOnly = readOnly;
      this.kbId = Messenger.reqres.request("active:kb");
      this.languagesWithDefault = Messenger.reqres.request(
        "fetch:kb:languagesWithDefault",
        this.kbId,
      );
      this.kbAttributes = Messenger.reqres.request("fetch:kb:attributes", this.kbId);

      var _this = this;
      this.topicAttributes.on("invalid", function (model, error) {
        _.each(error, function (errorMessage, attributeName) {
          if (
            "attributeId" === attributeName ||
            "attributeValue" === attributeName ||
            /localizedAttributeValue_/.test(attributeName)
          ) {
            _this.view.showError(errorMessage);
          }
        });
      });

      this.topicAttributes.onSynced(function () {
        this.topicAttributes.sort();
        this.kbAttributes.onSynced(function () {
          this.languagesWithDefault.onSynced(function () {
            this.selectedLanguage = this.languagesWithDefault.first();
            this._buildView();
            this.showRegion(this.view, {
              loading: true,
              entity: this.attributes,
            });
          }, this);
        }, this);
      }, this);
    },

    _getNextAvailableAttribute: function (attributeList, topicAttributeList) {
      var attributeId;
      var attributeName;
      var foundNext = false;
      attributeList.each(function (attribute) {
        if (!foundNext) {
          var nextAttribute = topicAttributeList.find(function (topicAttribute) {
            return topicAttribute.get("attributeId") == attribute.get("id");
          });
          if (_.isUndefined(nextAttribute)) {
            attributeId = attribute.get("id");
            attributeName = attribute.get("name");
            foundNext = true;
          }
        }
      });

      return {
        attributeId: attributeId,
        attributeName: attributeName,
      };
    },

    _addAttribute: function (attributeList, topicAttributeList) {
      // Next attribute available to add
      var nextAttribute = this._getNextAvailableAttribute(attributeList, topicAttributeList);
      if (!_.isUndefined(nextAttribute.attributeId)) {
        topicAttributeList.addAttribute(
          this.responseId,
          nextAttribute.attributeId,
          "",
          nextAttribute.attributeName,
        );
      } else {
        this.view.showError($.t("topic.attributes.allAttributesAdded"));
        return false;
      }
      return true;
    },

    _changeAttributeId: function (itemView, attributeId, attributeName, dataType) {
      itemView.model.backup();
      itemView.model.set("attributeId", attributeId);
      itemView.model.set("attributeName", attributeName);
      itemView.model.set("dataType", dataType);
      itemView.model.dirty = true;
    },
  });

  return TopicAttributesController;
});
